module.exports = __webpack_public_path__ + "static/media/16e-04_Chapas4-2016-398x290mm-lapiz-portaminas-HB-sobre-papel-70gr.2cbc20a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16e/16e-04_Chapas4-2016-398x290mm-lapiz-portaminas-HB-sobre-papel-70gr.png
// module id = 203
// module chunks = 0